import * as requests from '../api-request'

export const create = async (data = {}, token) => {
  return requests.toJSON('POST', 'plot_hole/create', data, token)
}

export const getList = async (data = {}, token) => {
  // skip store data if there is no token provided
  const queryString = new URLSearchParams(data)
  return requests.toJSON('GET', `plot_hole/list?${queryString}`, { }, token)
}

export const getResults = async (data = {}, token) => {
  // skip store data if there is no token provided
  const queryString = new URLSearchParams(data)
  return requests.toJSON('GET', `plot_hole/results?${queryString}`, { }, token)
}

export const plotHoleRenderPreview = async (data, token) => {
  return requests.toBlob('POST', 'plot_hole/plot_hole_summary', data, token)
}

export const regeneratePlot = async (data, token) => {
  return requests.toJSON('POST', 'plot_hole/regenerate_plot_hole', data, token)
}

export const resetPlot = async (data, token) => {
  return requests.toJSON('POST', 'plot_hole/reset_plot_hole', data, token)
}
